import React from "react";

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.hasError) {
      const label = this.props.label || "this section";
      return (
        <div className="p-4 rounded bg-[#1a0e0e] border border-red-900/40 text-xs text-red-300" data-testid="error-boundary">
          <strong className="text-red-200">Couldn't render {label}.</strong>
          <span className="opacity-70"> The rest of the page is still usable. Try refreshing.</span>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
